import { estopManager } from '@src/Main/estop';
import * as machinemotion from '@vse/api/machinemotion.js';
import { startConfigChecker } from '@vse/legacy/config_checker/config_checker.js';
import * as machinelogic from '@vse/main';
import { changePage } from '@vse/environment';

/**
 * @param {Library} library The MachineLogic Library.
 * @param {Navigate} navigate A function to navigate to another page.
 * @returns {void} Nothing.
 */
export function initializeConfigChecker (library, navigate) {
  changePage('configuration_checker'); // used by the ConfigManager to deploy config instantly (instead of waiting on the user to press the apply button)

  machinemotion.library(pData => {
    if (!pData) {
      return;
    }

    if (pData.status !== undefined) {
      return;
    }

    if (!pData.includes('#global')) {
      return;
    }

    // Fetch the #global application
    machinemotion.application('#global', function (pConfig) {
      machinelogic.standalone(library, navigate, { renderUi: false });

      const lContainer = $('#guiContainer');

      const queryParams = new URLSearchParams(location.search);
      const lTargetActuatorUuid = queryParams.get('uuid');
      const lTargetControllerUuid = queryParams.get('controllerId');

      startConfigChecker(
        lContainer,
        lTargetActuatorUuid,
        lTargetControllerUuid,
        pConfig,
        library,
        estopManager,
        navigate,
      );
    });
  });
}
